import { render, staticRenderFns } from "./MultilistPageLists.vue?vue&type=template&id=a4167350&scoped=true"
import script from "./MultilistPageLists.vue?vue&type=script&lang=js"
export * from "./MultilistPageLists.vue?vue&type=script&lang=js"
import style0 from "./MultilistPageLists.vue?vue&type=style&index=0&id=a4167350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4167350",
  null
  
)

export default component.exports